import { PREFIX_URL } from './config';

import { axios } from '../lib/axios/axios';

export const URLS = {};

URLS.BASE_URL = `${PREFIX_URL}/v01/inbox`;
// URLS.UPLOAD_DOCUMENT = `${PREFIX_URL}/files`;
URLS.UPLOAD_DOCUMENT = `${URLS.BASE_URL}/upload`;
URLS.USERS_ACCESS = `${PREFIX_URL}/v01/InboxAccess`;

export const fetchUsersAccess = async (projectId) => {
  const url = `${URLS.USERS_ACCESS}?projectId=${projectId}`;

  return await axios.get(url);
};
export const saveUsersAccess = async (params) => {
  return await axios.put(URLS.USERS_ACCESS, params);
};

export const uploadDocument = async (cancelToken, formDataFile, handleUploadProgress) => {
  return await axios.post(URLS.UPLOAD_DOCUMENT, formDataFile, {
    cancelToken: cancelToken.token,
    onUploadProgress: handleUploadProgress,
  });
};